var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoCard',{staticClass:"education-info",attrs:{"icon":"iconfont iconEducation","title":_vm.$t(`${_vm.i18nPrefix}.title.education`),"infoList":_vm.educationList,"infoLines":_vm.infoLines}})
}
var staticRenderFns = []

export { render, staticRenderFns }